module.exports = __webpack_public_path__ + "media/elevadizo/buqueDerecha-di-ap-2a703e80.png";